import React from 'react';

/** Unicode asterisk lookalikes → ASCII * (iOS, Word, ecc.) */
export function normalizeBoldMarkers(text) {
  if (!text) return '';
  return text.replace(/[\u2217\uFF0A\u2055\uFE61]/g, '*');
}

/**
 * Renders plain text with **bold** segments as <strong>.
 * Accetta solo coppie **testo** (asterisco ASCII, anche dopo normalizzazione).
 */
export function parseBoldText(text) {
  if (!text) return null;

  const normalized = normalizeBoldMarkers(text);
  const nodes = [];
  const regex = /\*\*(.+?)\*\*/g;
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = regex.exec(normalized)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(
        <span key={key++}>{normalized.slice(lastIndex, match.index)}</span>,
      );
    }
    const boldText = match[1];
    if (boldText.length > 0) {
      nodes.push(
        <strong key={key++} className="font-bold text-zinc-900">
          {boldText}
        </strong>,
      );
    } else {
      nodes.push(<span key={key++}>{match[0]}</span>);
    }
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < normalized.length) {
    nodes.push(<span key={key++}>{normalized.slice(lastIndex)}</span>);
  }

  return nodes.length > 0 ? nodes : normalized;
}
